import type { Schema } from '@cli-types/core-engine/schema.js'
import type { WebhookEventsResult } from '@cli-types/next-adapter/generators.js'
import { NO_WEBHOOK_SCHEMAS } from '@cli-constants/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { renderExtract } from './render-extract.js'

export function updateWebhookEvents(
  schema: Schema,
  webhookEventsDir: string,
  kind: 'entity' | 'single'
): WebhookEventsResult {
  if (NO_WEBHOOK_SCHEMAS.has(schema.name)) {
    return { files: [] }
  }

  const events =
    kind === 'single'
      ? [`${schema.name}.updated`]
      : [
          `${schema.name}.created`,
          `${schema.name}.updated`,
          `${schema.name}.deleted`,
          ...(schema.actions?.draft === true
            ? [`${schema.name}.published`, `${schema.name}.unpublished`]
            : []),
          `${schema.name}.restored`,
          `${schema.name}.reordered`
        ]

  return {
    files: [
      createGeneratedFile(
        `${webhookEventsDir}/${schema.name}.ts`,
        renderExtract(schema.name, kind, schema.label, events)
      )
    ]
  }
}
